import { Logger, StatusType, datadogLogs } from '@datadog/browser-logs';
import { getCommitHash } from 'sb-lib/env';

const env = process.env.DD_ENV;
const token = process.env.DD_CLIENT_TOKEN;
const level = process.env.DD_LOG_LEVEL as StatusType;

let datadogLogger = null as null | Logger;

if (token) {
  datadogLogs.init({
    env,
    clientToken: token,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: getCommitHash(),
    service: 'frontend',
  });
  datadogLogger = datadogLogs.logger;

  if (level) {
    datadogLogger.setLevel(level);
  }
}

export default datadogLogger;
